// HomePage.js
import React, { useState } from "react";
import PropTypes from "prop-types";
import { getUrl } from "aws-amplify/storage";
import { Link } from "react-router-dom";

import makeStyles from '@mui/styles/makeStyles';
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GetAppIcon from "@mui/icons-material/GetApp";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import OutlinedFlagRoundedIcon from "@mui/icons-material/OutlinedFlagRounded";
import Tooltip from "@mui/material/Tooltip";

// Snackbar
import Snackbar from "@mui/material/Snackbar";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";

// Styles
const useStyles = makeStyles({
  toolbar: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    alignSelf: "stretch",
    minHeight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: "12px",
    paddingRight: "12px",
  },
});

function ResultToolbar({ result, expand, authState }) {
  const classes = useStyles();

  // Set states
  const [open, setOpen] = useState(false); // Snackbar open state
  const [message, setMessage] = useState(""); // Snackbar message state
  const [sbBtn, setSbBtn] = useState(false); // Snackbar message button state

  function handleSnack(m, b) {
    setMessage(m);
    setSbBtn(b);
    setOpen(true);
  }

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  // PDF download information
  const frn = result.frn.raw;
  const vd = result.valid_date.raw;
  const s3Key = `${vd}/frn-${frn}_valid-${vd}.pdf`;

  async function downloadPDF() {
    handleSnack("Fetching PDF...", false);
    // v3 used level: "public" which maps to the "public/" prefix in the
    // bucket. v6's path-based API expects that prefix in the path itself.
    // validateObjectExistence makes Amplify issue a HEAD before signing
    // the URL — that uses s3:GetObject, so we don't need s3:ListBucket
    // on the guest role.
    const path = `public/${s3Key}`;
    try {
      const { url } = await getUrl({
        path,
        options: { expiresIn: 180, validateObjectExistence: true },
      });
      const dummyLink = document.createElement("a");
      dummyLink.href = url.toString();
      document.body.appendChild(dummyLink);
      dummyLink.click();
      document.body.removeChild(dummyLink);
      setTimeout(() => {
        setOpen(false);
      }, 1000);
    } catch (e) {
      // S3 returns 404 (NotFound) when the object isn't there; anything
      // else (403, network, etc.) we treat as a generic failure.
      const notFound =
        e?.name === "NotFound" ||
        e?.$metadata?.httpStatusCode === 404 ||
        (typeof e?.message === "string" && e.message.toLowerCase().includes("not found"));
      if (notFound) {
        handleSnack("File not found. Please contact us for support.", false);
      } else {
        console.error("PDF download failed for", path, e);
        handleSnack("An error occured. Please contact us for support.", false);
      }
    }
  }


  return (
    <Toolbar
      disableGutters={true}
      className={ classes.toolbar }
    >
      <IconButton
        size="small"
        color="default"
        onClick={(event) => {
          event.stopPropagation();
          downloadPDF();
        }}
        onFocus={(event) => event.stopPropagation()}
      >
        <Tooltip title="Download PDF">
          <GetAppIcon fontSize="small" />
        </Tooltip>
      </IconButton>
      <IconButton
        size="small"
        color="default"
      >
        {expand ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
      </IconButton>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleSnackClose}
        message={message}
        action={
          <>
            {sbBtn &&
              <Button color="secondary" size="small" onClick={handleSnackClose} component={Link} to="/auth">
                SIGN IN
              </Button>
            }
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleSnackClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      />
    </Toolbar>
  );
}

ResultToolbar.propTypes = {
    result: PropTypes.object,
    expand: PropTypes.bool,
    authState: PropTypes.string,
};

export default ResultToolbar;

// <Tooltip title="Get Notifications">
//   <IconButton
//     size="small"
//     color="default"
//     onClick={() => handleSnack("Get Notifications feature coming soon!", false)}
//     >
//       <NotificationsNoneIcon fontSize="small" />
//   </IconButton>
// </Tooltip>
// <Tooltip title="Report Issue">
//   <IconButton
//     size="small"
//     color="default"
//     onClick={() => handleSnack("Report Issue feature coming soon!", false)}>
//     <OutlinedFlagRoundedIcon fontSize="small" />
//   </IconButton>
// </Tooltip>
